/**
 * 西班牙语（es）
 */
export default {
  orderList: {
    AllOrder: 'Todo orden',
    WaitingPayment: 'Esperando el pago',
    Pending: 'Esperando el envío',
    ToBeSighed: 'En el camino',
    Refunding: 'Reembolso',
    YouHave: 'Tienes',
    orders: 'Orden',
    OrderID: 'Número de orden',
    Customer: 'Cliente',
    coupon: 'Cupón',
    TotalAmount: 'Importe total',
    PayNow: 'Pago ahora',
    ViewDetails: 'Ver detalles',
    CancelDelivery: 'Cancelación de la entrega',
    CancelOrder: 'Cancelar orden',
    Delete: 'Borrar',
    selectContent: 'Seleccionar contenido',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha final',
    inputPlaceholder: 'Búsqueda por ID de pedido, SKU o nombre del producto',
    RequestRefund: 'Solicitud de reembolso',
    ConfirmReceipt: 'Acuse de recibo',
    CancelReason: 'Motivos de cancelación',
    Verification: 'Verificación',
    RefundReason: 'Motivos de la restitución',
    Remake: 'Comentario',
    cancel: 'Cancelar',
    submit: 'Decisiones',
    ConfirmReceiptTitle: '¿Está seguro de que ha recibido las mercancías y de que la calidad se ajusta al Acuerdo de ambas partes?',
    ConfirmReceiptContent: 'Si la confirmación es correcta, por favor haga clic en el botón "confirmar" a continuación para completar la confirmación de recepción.',
    removeTheStore: 'Eliminar almacenamiento',
    CancellationReasonIsRequired: 'La razón de cancelación es necesaria',
    RefundReasonIsRequired: 'La razón del reembolso es necesaria',
    Paypal: 'Paypal',
    CreditCard: 'Tarjeta de crédito',
    Balance: 'Equilibrio',
    SelectByStatus: 'Selección por Estado',
    SelectByPlatform: 'Seleccionar por plataforma',
    FulfillOrder: 'Completar el pedido',
    Store: 'Centro Comercial',
    StoreOrderID: 'ID de pedido de la tienda',
    TrackingNumber: 'Número de consulta',
    ShippingCarrier: 'Transportista',
    TrackingURL: 'Sitio web de seguimiento',
    cancelBtn: 'Cancelar',
    ok: 'Muy bien',
    emptyTips1: '¡Su pedido está vacío!',
    emptyTips2: 'Aquí puede administrar y procesar pedidos',
    ChooseProduct: 'Selección de productos',
    ChooseProductTips: 'Cómo encontrar y listar prodcuts',
    ConnectANewStore: 'Conectar una nueva tienda',
    ConnectANewStoreTips: 'Cómo conectar una nueva tienda',
    selectAll: 'Selección completa',
    orderStatusSubTip: 'Reembolso fallido, póngase en contacto con nuestro equipo de apoyo',
    Remark: 'Observación',
    PleaseSelectThePaymentMethod: 'Por favor seleccione el método de pago'
  },
  orderDetail: {
    PayNow: 'Pago ahora',
    ConfirmReceipt: 'Acuse de recibo',
    StoreOrderID: 'ID de pedido de la tienda',
    OrderID: 'Número de orden',
    Source: 'Fuente',
    IncomeStatement: 'Estado de ingresos',
    CommodityInformation: 'Información sobre los productos básicos',
    ShipFrom: 'De',
    ItemNo: 'Número de proyecto',
    TheDetail: 'Detalles',
    Notes: 'Notas',
    OrderStatus: 'Estado del pedido',
    BalancePayment: 'Balanza de pagos',
    PaymentTime: 'Tiempo de pago',
    PaymentId: 'ID de pago',
    ItemSubtotal: 'Subtotal',
    ShippingSubtotal: 'Entrega',
    tax: 'Impuestos',
    PaymentAmount: 'Importe del pago',
    ShippingAddress: 'Dirección de entrega',
    ConfirmReceiptModalTitle: '¿Está seguro de que ha recibido las mercancías y de que la calidad se ajusta al Acuerdo de ambas partes?',
    ConfirmReceiptModalContent: 'Si la confirmación es correcta, por favor haga clic en el botón "confirmar" a continuación para completar la confirmación de recepción.',
    Cancel: 'Cancelar',
    Apply: 'Aplicar',
    Replace: 'Reemplazar',
    Submit: 'Entregar',
    removeTheStore: 'Eliminar almacenamiento',
    WaitingPayment: 'Esperando el pago',
    WaitingPaymentTips: 'Su pedido aún no ha sido pagado. Haga clic en pagar ahora para continuar.',
    OrderCreation: 'Creación de pedidos',
    Finish: 'Complete',
    PaymentSuccessful: 'Pago exitoso',
    IncorrectAddressInformation: 'Información de dirección incorrecta',
    CancelTips: 'Su pedido ha sido cancelado con éxito',
    Pending: 'Esperando el envío',
    PendingSecondStatus: 'Normalmente no más de 24 horas.',
    PendingTips: 'Cada producto ha sido sometido a nuestro estricto control de calidad antes de ser enviado a su cliente.',
    Shipped: 'Envío',
    Complete: 'Completo',
    ShippedTips1: '¡Su pedido llegará pronto!',
    PartialDelivery: 'Envío parcial',
    ShippedTips2: 'Algunos de sus productos aún no han sido enviados',
    Refunding: 'Reembolso',
    PartialRefund: 'Reembolso parcial',
    refundedTipsNew: 'El importe total del reembolso de su pedido es',
    RefundingSecondStatus: 'Su reembolso será procesado en 1 - 3 días hábiles',
    RefundingTips: 'Se ha presentado una solicitud de reembolso. Esperando el procesamiento',
    Refund: 'Reembolso',
    Refunded: 'Devolución',
    RefundedSecondStatus: 'Dependiendo de su institución financiera, los fondos se mostrarán en su cuenta durante un máximo de 14 días',
    RefundedTips: 'La solicitud de reembolso ha sido aceptada. El importe pagado se devolverá en la forma de pago original.',
    CompleteSecondStatus: 'Finalización de la transacción',
    CompleteTips: 'El pedido está completo, gracias por su apoyo.',
    ShippingMethod: 'Modo de transporte',
    MyOrder: 'Mi pedido',
    OrderInformation: 'Información del pedido',
    Product: 'Productos',
    PurchasePrices: 'Precio de compra',
    prices: 'Precio',
    Quantity: 'Cantidad',
    Subtotal: 'Subtotal',
    Profit: 'Beneficios',
    ConfirmReceiptTips: 'Cuidado con el recibo.',
    trackingCode: 'Código de seguimiento',
    DeliveryTime: 'Tiempo de envío',
    logisticsProviders: 'Proveedores logísticos',
    payment: 'Pago',
    NotToDeliverGoods: 'No entrega',
    LogisticsInformation: 'Información logística',
    PartialDeliveryTips: 'Algunos productos aún no se han enviado, le informaremos una vez que se haya enviado',
    PaymentInformation: 'Información sobre el pago',
    Balance: 'equilibrio',
    CreditCard: 'tarjeta de crédito',
    payFail: 'Pago fallido',
    Remaining: 'El resto',
    WaitingPaymentWarning: 'Los pedidos pendientes durante más de 120 horas serán cancelados',
    OrderCancelled: 'Orden cancelada',
    OrderConfirmed: 'Confirmación del pedido',
    Shipping: 'Transporte marítimo',
    OrderComplete: 'Entregado',
    OrderSubmitted: 'Orden presentada',
    promotion: 'Código promocional',
    Discount: 'Descuento',
    PleaseInput: 'Por favor, input',
    Note: 'Nota',
    EditNote: 'Editar nota',
    Edit: 'Editar',
    EditNoteSuccessTip: 'El contenido de la nota se actualizó correctamente.',
    NoteTip: 'Aquí está el contenido de la nota.'
  },
  orderRefund: {
    OK: 'OK',
    ALL: 'TODO',
    Refund: 'Reembolso',
    AllOrder: 'Todos los pedidos',
    RefundApplication: 'Solicitud de reembolso',
    OrderHasBeenRefundedBefore: 'El pedido ha sido reembolsado antes',
    RefundRecord: 'Registro de reembolso',
    RefundReason: 'Motivo del reembolso',
    InputContent: 'Contenido de entrada',
    Remarks: 'Observaciones',
    RefundedAmount: 'Importe reembolsado',
    ItemSubtotal: 'Subtotal de artículo',
    ShippingSubtotal: 'Subtotal de envío',
    Promotion: 'Promoción',
    Total: 'Total',
    RefundRequestFailed: 'Solicitud de reembolso fallida',
    ThereIsErrorWithYouRequest: 'Hay un error con su solicitud',
    PleaseConnectOurSupportTeam: 'Por favor conecte nuestro equipo de soporte',
    RufundID: 'ID de reembolso',
    RufundTime: 'Tiempo de reembolso',
    RefundAmount: 'cantidad devuelta',
    RefundSucceeded: 'Reembolso exitoso',
    RefundFailed: 'Reembolso fallido'
  },
  Order: {
    Sales: {
      Web: {
        Index: {
          RefundingOrder: 'Orden de reembolso',
          PaymentMethod: 'Método de pago',
          State: 'Estado',
          StartDate: 'Fecha de inicio',
          EndDate: 'Fecha final',
          SearchingFor: 'buscando',
          Processing: 'Procesando',
          Refunding: 'Reembolso',
          Rejected: 'Rechazado',
          Completed: 'Terminado',
          IusseID: 'Iusse ID',
          OrderID: 'Solicitar ID',
          RefundAmount: 'cantidad devuelta',
          CreationTime: 'Tiempo de creación',
          Type: 'Tipo',
          NoRecord: 'Sin registro'
        }
      },
      Details: {
        Web: {
          Index: {
            RefundingOrder: 'Orden de reembolso',
            RufundOrderDetails: 'Detalles del pedido de reembolso',
            OrderInformation: 'información del pedido',
            ReviewTime: 'Tiempo de revisión',
            ReviewID: 'Identificador de revisión',
            RefundRecord: 'Registro de reembolso',
            RufundInformation: 'Información de reembolso',
            OrderID: 'Solicitar ID',
            ParcelCode: 'Código de paquete',
            PaymentTime: 'Tiempo de pago',
            NoRecord: 'Sin registro',
            RefundedAmount: 'Importe reembolsado',
            Subtotal: 'Total parcial',
            ShippingFee: 'Gastos de envío',
            PromoCode: 'Código promocional',
            Coupon: 'Cupón',
            Total: 'Total',
            ShippingAddress: 'Dirección de envío',
            Processing: 'Procesando',
            Refunding: 'Reembolso',
            Rejected: 'Rechazado',
            Completed: 'Terminado'
          },
          Components: {
            SkuInfoItemTwo: {
              CustomizedService: 'Servicio Personalizado',
              Tips1: 'Cadena de cintura asimétrica con decoración floral',
              StoreSKU: 'SKU de la tienda',
              QTY: 'QTY',
              RefundAmount: 'cantidad devuelta'
            },
            RefundRecordItem: {
              RufundID: 'ID de reembolso',
              RufundTime: 'Tiempo de reembolso',
              RefundAmount: 'cantidad devuelta',
              RefundApplication: 'Solicitud de reembolso',
              RefundSucceeded: 'Reembolso exitoso',
              RefundFailed: 'Reembolso fallido'
            },
            RefundRecordDialog: {
              NoRecord: 'Sin registro'
            }
          }
        }
      }
    },
    Refund: {
      Web: {
        Index: {
          MyOrder: 'Mi pedido',
          RefundApplication: 'Solicitud de reembolso',
          RufundOrder: 'Orden de reembolso',
          OrderHasBeenRefundedBefore: 'El pedido ha sido reembolsado antes',
          RefundRecord: 'Registro de reembolso',
          InputContent: 'Contenido de entrada',
          PleaseEnterRemarks: 'Por favor ingrese Comentarios',
          RefundedAmount: 'Importe reembolsado',
          Subtotal: 'Total parcial',
          ShippingFee: 'Gastos de envío',
          PromoCode: 'Código promocional',
          Coupon: 'Cupón',
          Total: 'Total',
          Refund: 'Reembolso',
          RefundReason: 'Motivo del reembolso',
          Tips1: 'Seleccione un motivo de reembolso.',
          OutOfStock: 'Agotado',
          ShipmentDelay: 'Retraso del envío',
          DonTWantAnymore: 'no quiero mas',
          IncorrectAddressInformation: 'Información de dirección incorrecta',
          ProductSelectionErrorMultipleSelection: 'Error de selección de producto/Selección múltiple',
          Other: 'Otro'
        },
        Components: {
          SkuInfoItemOne: {
            CustomizedService: 'Servicio Personalizado',
            Tips1: 'Cadena de cintura asimétrica con decoración floral',
            StoreSKU: 'SKU de la tienda',
            Price: 'Precio',
            Total: 'Total',
            QTY: 'QTY',
            RefundableAmount: 'Importe reembolsable'
          },
          RefundRecordItem: {
            RufundID: 'ID de reembolso',
            RufundTime: 'Tiempo de reembolso',
            RefundAmount: 'cantidad devuelta',
            RefundApplication: 'Solicitud de reembolso',
            RefundSucceeded: 'Reembolso exitoso',
            RefundFailed: 'Reembolso fallido'
          },
          RefundRecordDialog: {
            NoRecord: 'Sin registro'
          },
          NotShippedGoods: {
            NotShipped: 'No enviado',
            SelectAll: 'Seleccionar todo',
            NoRecord: 'Sin registro'
          }
        }
      },
      Success: {
        Web: {
          Index: {
            MyOrder: 'Mi pedido',
            RufundOrder: 'Orden de reembolso',
            AllOrders: 'Todas las órdenes',
            SubmittedSuccessfully: 'Enviado satisfactoriamente',
            WaitingForReview: 'Esperando para revisión',
            Back: 'Atrás',
            CheckAfterSales: 'Comprobar después de la venta',
            RufundInformation: 'Información de reembolso',
            OrderID: 'Solicitar ID',
            TrackingCode: 'Codigo de localización',
            PaymentTime: 'Tiempo de pago',
            NoRecord: 'Sin registro',
            RefundedAmount: 'Importe reembolsado',
            ItemSubtotal: 'Subtotal de artículo',
            ShippingSubtotal: 'Subtotal de envío',
            Promotion: 'Promoción',
            Total: 'Total',
            ShippingAddress: 'Dirección de envío'
          },
          Components: {
            SkuInfoItemTwo: {
              CustomizedService: 'Servicio Personalizado',
              Tips1: 'Cadena de cintura asimétrica con decoración floral',
              StoreSKU: 'SKU de la tienda',
              RefundQuantity: 'Cantidad de reembolso',
              RefundAmount: 'cantidad devuelta'
            }
          }
        },
        Mobile: {
          Index: {
            SubmittedSuccessfully: 'Enviado satisfactoriamente',
            WaitingForReview: 'Esperando para revisión',
            AllOrders: 'Todas las órdenes'
          },
          Components: {
            GoodItem: {
              RefundQuantity: 'Cantidad de reembolso',
              RefundAmount: 'cantidad devuelta'
            }
          }
        }
      },
      Mobile: {
        Index: {
          Rufund: 'Reembolso',
          Tips1: 'El pedido ha sido reembolsado antes',
          ViewRefundHistory: 'Ver historial de reembolso',
          NoRecord: 'Sin registro',
          RefundedAmount: 'Importe reembolsado',
          Subtotal: 'Total parcial',
          ShippingFee: 'Gastos de envío',
          PromoCode: 'Código promocional',
          Coupon: 'Cupón',
          Total: 'Total',
          Refund: 'Reembolso',
          OutOfStock: 'Agotado',
          ShipmentDelay: 'Retraso del envío',
          DonTWantAnymore: 'no quiero mas',
          IncorrectAddressInformation: 'Información de dirección incorrecta',
          ProductSelectionErrorMultipleSelection: 'Error de selección de producto/Selección múltiple',
          Other: 'Otro',
          RefundReason: 'Motivo del reembolso'
        },
        Components: {
          RefundRecord: {
            NoRecord: 'Sin registro'
          },
          NotShippedGoods: {
            NotShipped: 'No enviado',
            SelectAll: 'Seleccionar todo',
            NoRecord: 'Sin registro'
          },
          GoodItem: {
            Item: 'Artículo',
            ItemPrice: 'Precio',
            Total: 'Total',
            Quantity: 'Cantidad',
            RefundableAmount: 'Importe reembolsable'
          }
        }
      }
    },
    List: {
      Index: {
        WaitingPayment: 'Esperando el pago',
        WaitingToShip: 'esperando para enviar',
        InTransit: 'En tránsito',
        RefundReturn: 'Reembolso y devolución',
        OrderInfoMissing: 'Pedidos anormales' // 'Falta la información del pedido'
      },
      Components: {
        TrackingDialog: {
          TrackingNo: 'número de seguimiento',
          LastCarrier: 'Último transportista',
          FirstCarrier: 'primer transportista',
          LogisticsTrackingInformation: 'Información de seguimiento de logística',
          TrackingNoFromLastCarrier: 'Número de seguimiento del último transportista',
          TrackingNoFromFirstCarrier: 'Nº de seguimiento del primer transportista',
          PosteItaliane: 'Correo italiano',
          Tips1: 'Información de seguimiento de logística'
        },
        PayDialog: {
          ShippingAddress: 'Dirección de envío',
          Edit: 'Editar',
          OrderAmount: 'Total de la orden',
          Subtotal: 'Total parcial',
          ShippingFee: 'Gastos de envío',
          Discount: 'Descuento',
          PromoCode: 'Código promocional',
          Total: 'Total',
          Others: 'Otros',
          PayNow: 'Pagar ahora',
          CustomizedService: 'Servicio Personalizado',
          DeliveryMethod: 'Método de entrega',
          Warehouses: 'Almacenes',
          LogisticsError: 'Error de logística',
          Tips1: 'Conecta con nuestro equipo de soporte para continuar',
          PaymentAmount: 'Monto del pago',
          Tags: 'Etiquetas',
          Package: 'Paquete (Próximamente)',
          Bags: 'Bolsas (Próximamente)',
          SoldOutProduct: 'Los productos se han agotado',
          ContinueToPay: 'Seguir pagando',
          Tips2: 'Por favor seleccione un cupón'
        },
        OrderStatusTag: {
          WaitingPayment: 'Esperando el pago',
          Complete: 'Completo',
          Cancel: 'Cancelar',
          WaitingToShip: 'esperando para enviar',
          FullyShipped: 'Totalmente enviado',
          PartialShipped: 'Enviado parcialmente',
          Refunding: 'Reembolso',
          PartialRefund: 'Reembolso parcial',
          Refunded: 'Reintegrado',
          AbnormalOrder: 'Pedidos anormales'
        },
        MTStatusList: {
          SelectAll: 'Seleccionar todo',
          Products: 'productos'
        },
        Mobile: {
          AllOrder: 'Todos los pedidos',
          WaitingPayment: 'Esperando el pago',
          WaitingToShip: 'esperando para enviar',
          InTransit: 'En tránsito',
          RefundReturn: 'Reembolso y devolución',
          Completed: 'Terminado',
          Cancel: 'Cancelar',
          OrderInfoMissing: 'Pedidos anormales' // 'Falta la información del pedido'
        },
        ListTopFilter: {
          PaymentStatus: 'Estado de pago',
          WaitingPayment: 'Esperando el pago',
          PartialRefund: 'Reembolso parcial',
          Refunding: 'Reembolso',
          Refunded: 'Reintegrado',
          WaitingToShip: 'esperando para enviar',
          PartialShipped: 'Enviado parcialmente',
          FullyShipped: 'Totalmente enviado',
          Complete: 'Completo',
          Cancel: 'Cancelar',
          ExportFailed: 'Exportación fallida',
          ExportAgain: 'Exportar de nuevo',
          ShipmentStatus: 'Estado del envío',
          ExportOrder: 'Orden de exportación'
        },
        EmptyNoStore: {
          Tips1: 'Lo sentimos, no tienes ningún pedido.'
        },
        EmptyLogistics: {
          Tips1: 'La información logística aún no se ha actualizado.'
        },
        EmptyDataWithParams: {
          Tips1: 'Lo siento, no puedo encontrar ~ Por favor busca de nuevo'
        },
        AllStatus: {
          AutoCheckout: 'Pago automático',
          OrdersSelected: 'Pedidos seleccionados',
          Tips1: 'Los nuevos pedidos de pago se pagarán automáticamente usando el valor predeterminado',
          Tips2: 'método de pago',
          Tips3: 'en archivo',
          Source: 'Fuente',
          StoreOrderID: 'ID de pedido de la tienda',
          Accessories: 'Accesorios',
          StoreSKU: 'SKU de la tienda',
          RefundFailed: 'Reembolso fallido',
          AutoCheckoutFailed: 'Pago automático fallido',
          PartialRefund: 'Reembolso parcial',
          Refunded: 'Reintegrado',
          Products: 'productos',
          CompleteInformation: 'Información completa',
          ExportFailed: 'Exportación fallida',
          ExportAgain: 'Exportar de nuevo',
          AcceptedCardTypes: 'Tipos de tarjeta aceptados',
          Tips4: 'Para usar el pago automático, debe tener un',
          Tips5: 'método de pago en su cuenta.',
          AddACard: 'Añade una tarjeta',
          ExportOrder: 'Orden de exportación',
          Agree: 'De acuerdo',
          Reject: 'Rechazar',
          Tips6: '¿¿ está de acuerdo en que los compradores de shopify cancelen la solicitud de envío?',
          Tips7: 'Acepte cancelar el envío, si no necesita enviar kaka, solicite un reembolso a tiempo.',
          Tips8: 'Todos los productos están agotados'
        },
        AddressWrongPayDialog: {
          Tips1: 'A estos pedidos les falta información requerida',
          OrderID: 'Solicitar ID',
          ContinueToPay: 'continuar pagando'
        }
      }
    },
    Details: {
      Index: {
        Invoice: 'factura',
        RefundRecord: 'Registro de reembolso',
        ShippingSoon: 'Envío pronto',
        Tips1: 'El artículo está agotado, comuníquese con el servicio al cliente',
        ParcelCode: 'Código de paquete',
        LogisticsInformation: 'información logística',
        ConfirmReceipt: 'Confirmar recibo',
        ConfirmReceiptPrompt: '¿Recibiste todos los artículos de este paquete?',
        Confirm: 'Confirmado',
        Cancel: 'Cancelación',
        Completed: 'Terminado',
        DeliveryTime: 'Tiempo de envío',
        // TrackingCode: 'Codigo de localización',
        TrackingCode: 'El número de rastreo',
        // TailTrackingCode: 'Código de seguimiento de cola',
        TailTrackingCode: 'Número de seguimiento de última milla',
        ShipmentTracking: 'rastreo de envío',
        LogisticsProviders: 'Proveedores de logística',
        Accessories: 'Accesorios',
        StoreSKU: 'SKU de la tienda',
        Weight: 'Peso',
        Remark: 'Observación',
        CompleteInformation: 'Información completa'
      },
      Components: {
        TraningLineMt: {
          TrackingNo: 'número de seguimiento',
          LastCarrier: 'Último transportista',
          ParcelCode: 'Código de paquete',
          FirstCarrier: 'primer transportista'
        },
        TopTimeLine: {
          RefundFailed: 'Reembolso fallido',
          WaitingPayment: 'Esperando el pago',
          PayNow: 'Pagar ahora',
          Tips1: 'Tu pedido aún no ha sido pagado. Haga clic en "Pagar ahora" para continuar.',
          OrderSubmitted: 'orden enviada',
          OrderConfirmed: 'orden confirmada',
          Shipped: 'Enviado',
          OrderComplete: 'orden completada',
          Tips2: 'Cada producto pasa por nuestra rigurosa inspección de calidad antes de enviarlo a sus clientes.',
          WaitingToShip: 'esperando para enviar',
          PartialShipped: 'Enviado parcialmente',
          Tips3: 'Algunos productos aún no se han enviado, le informaremos una vez que se haya enviado',
          Shipping: 'Envío',
          FullyShipped: 'Totalmente enviado',
          Tips4: '¡Tu pedido está en camino!',
          Completed: 'Terminado',
          Tips5: 'Sus productos se envían fuera del almacén y están en tránsito',
          Cancel: 'Cancelar',
          Tips6: 'Su pedido ha sido cancelado con éxito',
          Finish: 'Finalizar',
          AbnormalOrder: 'Pedidos anormales',
          Tips7: 'Información incompleta del destinatario',
          Tips8: 'No se puede obtener logística',
          GetLogistics: 'Acceso a la logística'
        },
        RefundRecordMobile: {
          RufundID: 'ID de reembolso',
          RufundTime: 'Tiempo de reembolso',
          RefundAmount: 'cantidad devuelta'
        },
        RefundRecord: {
          RufundID: 'ID de reembolso',
          RufundTime: 'Tiempo de reembolso',
          RefundAmount: 'cantidad devuelta',
          RefundRecord: 'Registro de reembolso',
          RefundApplication: 'Solicitud de reembolso',
          RefundedRefundAmount: 'Monto de reembolso reembolsado',
          RefundFailed: 'Reembolso fallido'
        },
        MTDetail: {
          OrderInformation: 'Información del pedido',
          ShippingSoon: 'Envío pronto',
          LogisticsInformation: 'información logística',
          ParcelCode: 'Código de paquete',
          TrackYourShipment: 'Rastrea tu envío',
          ConfirmReceipt: 'Confirmar recibo',
          OrderID: 'Solicitar ID',
          StoreOrderID: 'ID de pedido de la tienda',
          Source: 'Fuente',
          Store: 'Almacenar',
          ShippingMethod: 'Método de envío',
          PaymentInformatio: 'Información del pago',
          PaymentTime: 'Tiempo de pago',
          PaymentMethod: 'Método de pago',
          Subtotal: 'Total parcial',
          Delivery: 'Entrega',
          Promotion: 'Promoción',
          Total: 'Total Cantidad',
          Invoice: 'factura',
          PayNow: 'Pagar ahora',
          Refunding: 'Reembolso',
          PartialRefund: 'Reembolso parcial',
          Refunded: 'Reintegrado',
          PaymentAmount: 'Monto del pago'
        },
        CancelMT: {
          Submit: 'Entregar'
        }
      }
    },
    Custom: {
      Web: {
        Index: {
          CustomOrders: 'Pedidos personalizados',
          NoRecord: 'Sin registro',
          Export: 'Exportar'
        }
      }
    }
  },
  Dropshipping: {
    Module1: {
      Title1: 'Aprende sobre el dropshipping de KakaClo',
      Title2: 'Ropa',
      Title3: 'Dropshipping',
      Title4: 'Nunca ha sido tan fácil',
      Sub1: '· Encuentra los mejores productos de dropshipping de proveedores verificados',
      Sub2: '· Completamente gratuito',
      Sub3: '· Adecuado para principiantes en dropshipping de Shopify y TikTok',
      StartSelling: 'Comenzar a Vender',
      SignUpForFree: 'Registrarse Gratis'
    },
    Module2: {
      Title1: 'El Centro de Control de Calidad de KakaClo proporciona',
      Title2: 'a los clientes la',
      Title3: 'Mejor Calidad',
      Title4: 'Por qué elegir KakaClo para el dropshipping de ropa',
      Sub1: 'KakaClo aplica estrictas inspecciones de calidad a cada pieza antes de enviarlas, por lo que puedes estar tranquilo respecto a la satisfacción del cliente en cuanto a la calidad de los productos.',
      Sub2: 'KakaClo, la plataforma líder en la cadena de suministro de ropa, ofrece servicio de dropshipping para productos disponibles en stock en almacenes europeos y americanos.',
      CaptionTitle1: 'Empaquetado discretamente',
      CaptionTitle2: 'Proporcionar muestra',
      CaptionTitle3: 'Diseño original',
      CaptionTitle4: 'Materiales y procesos crudos',
      CaptionTitle5: 'Excelente servicio postventa',
      CaptionTitleAdditiona1: '(Se puede personalizar según sea necesario)',
      CaptionTitleAdditiona2: '(Se puede solicitar ropa de muestra)',
      CaptionTitleAdditiona3: '(Fábrica y diseñador propios)',
      CaptionTitleAdditiona4: '(La fábrica original controla materias primas y procesos)',
      SelectReasonTitle1: 'Equipo profesional de I+D y su propia fábrica de ropa',
      SelectReasonTitle2: 'Centro de inspección de calidad independiente',
      SelectReasonTitle3: 'Sistema global de logística y almacenes',
      SelectReasonTitle4: 'Soluciones de integración fáciles de usar',
      SelectReasonTitleAdditiona1: 'KakaClo proporciona a los clientes los últimos artículos únicos y de moda con precios súper competitivos',
      SelectReasonTitleAdditiona2: 'A diferencia de otros proveedores de dropshipping, KakaClo realiza estrictas inspecciones de calidad antes de enviar cada pieza.',
      SelectReasonTitleAdditiona3: 'Garantiza un procesamiento y entrega de pedidos rápidos y efectivos, y ahora tiene almacenes en Europa, América y China.',
      SelectReasonTitleAdditiona4: 'Los usuarios de KakaClo pueden agregar fácilmente sus propias tiendas a la plataforma de KakaClo y cargar productos con solo unos clics.',
      advantageTitle1: 'Vende con facilidad',
      advantageTitle2: 'Inventario siempre actualizado',
      advantageTitle3: 'Productos de la mejor calidad',
      advantageTitle4: 'Gran margen de beneficio',
      advantageTitle5: 'Entrega súper rápida',
      Questions1: '¿Cómo asegura KakaClo la calidad de los productos de dropshipping?',
      LinkUrl1: 'Aprende sobre el dropshipping de KakaClo'
    },
    Module3: {
      Title1: 'Cómo funciona el dropshipping en KakaClo',
      Title2: 'Listar producto',
      Title3: 'Recibir pedido',
      Title4: 'Verificar calidad',
      Title5: 'Empaquetar pedido',
      Sub1: 'Sube productos de KakaClo a la tienda de Shopify y TikTok con un solo clic.',
      Sub2: 'Tu cliente realiza un pedido en tu tienda en línea',
      Sub3: 'Estricta inspección de calidad antes de enviar cada pieza.',
      Sub4: 'Entrega rastreable en tiempo real realizada por KakaClo',
      StartNow: 'Comienza ahora'
    },

    Module4: {
      Title1: 'Guía imprescindible para el dropshipping de ropa'
    },
    Module5: {
      Title1: 'Las últimas incorporaciones a la línea de productos de dropshipping',
      Sub1: 'Ropa de mujer',
      Sub2: 'Ropa de hombre',
      Sub3: 'Accesorios'
    },
    Module7: {
      Title1: 'Comienza a vender gratis',
      Sub1: 'Haz crecer tu negocio de moda con KakaClo',
      StartSelling: 'Comienza a vender'
    },
    Module8: {
      Title1: 'Consejos para el primer encuentro con el dropshipping',
      Questions1: '¿Es buena la ropa para el dropshipping?',
      Questions2: '¿Cómo elegir a los mejores proveedores de dropshipping?',
      Questions3: '¿Es adecuado el dropshipping de KakaClo para boutiques/tiendas?',
      Questions4: '¿Hay un contrato a largo plazo para el dropshipping de KakaClo?',
      Questions5: '¿Pueden personalizar el embalaje para mí?',
      Questions6: '¿Hay una cantidad mínima de pedido para cada producto?',
      Questions7: '¿Cómo procesar un pedido de dropshipping?',
      Questions8: '¿Ofrecen servicios de dropshipping de impresión bajo demanda (POD)?',
      Answer1: 'Sí, la ropa es uno de los productos adecuados para el dropshipping. El dropshipping es un modelo minorista donde puedes vender ropa sin tener inventario, y cumplir pedidos directamente desde proveedores una vez que se realizan. Esto hace que las operaciones sean más flexibles, pero la clave del éxito radica en elegir proveedores confiables e identificar un mercado objetivo atractivo.',
      Answer2: '<p>La selección de proveedores de dropshipping de ropa implica varias consideraciones como el precio, el servicio postventa, la fuente de los productos y más. Se pueden tener en cuenta los siguientes factores.</p><ul><li>¿Cómo manejan las devoluciones o productos dañados?</li><li>¿Cuánto tardan en cumplir un pedido, desde la venta hasta la entrega?</li><li>¿Cómo es su servicio al cliente? (Siéntete libre de probarlo tú mismo.)</li><li>¿Aseguran los pedidos?</li><li>¿Ofrecen protección contra fraudes?</li><li>¿Puedes encontrar reseñas o referencias en línea?</li></ul>',
      Answer3: '¡Sí! Numerosas tiendas físicas utilizan KakaClo para establecer presencia en línea sin tener que listar su inventario en la tienda web.',
      Answer4: 'No.',
      Answer5: '¡Claro! Podemos proporcionar tarjetas de agradecimiento, etiquetas colgantes, cajas o bolsas impresas/diseñadas personalizadas, lo que necesites.',
      Answer6: 'No.',
      Answer7: '<p>Al crear una cuenta en KakaClo, puedes comenzar con el dropshipping en KakaClo.</p><p>Supongamos que Timothy es un cliente de Tu Tienda.</p><ol><li>1. Timothy encuentra un producto que le gusta y lo compra en tu tienda.</li><li>2. El pedido de Timothy se coloca automáticamente con nosotros, cumplimos con el pedido y se lo enviamos a Timothy, y cobramos por el cumplimiento tan pronto como se confirma el pedido.</li></ol><p>Si Timothy compra una camiseta por $20 en tu tienda, el precio de KakaClo por el producto y el cumplimiento es de $8 en total. Así que de los $20 que Timothy pagó por la camiseta, obtienes una ganancia de $12.</p><p>Así es como funciona el dropshipping de KakaClo para sus usuarios.</p>',
      Answer8: 'Ofrecemos servicios POD (impresión bajo demanda), que incluyen varios productos únicos como camisetas, sudaderas, zapatos, bolsos, calcetines, sombreros y más.'
    }
  }
}
